import { Color } from "../../../maths/Color";
import { Vector4 } from "../../../maths/Vector4";
import { Shader3D } from "../../../RenderEngine/RenderShader/Shader3D";
import { Blit2DQuadCMD, Draw2DElementCMD, SetRendertarget2DCMD } from "../../DriverDesign/2DRenderPass/IRender2DCMD";
import { RenderCMDType } from "../../DriverDesign/RenderDevice/IRenderCMD";
export class WebGLSetRendertarget2DCMD extends SetRendertarget2DCMD {
    constructor() {
        super();
        this.type = RenderCMDType.ChangeRenderTarget;
        this._clearColorValue = new Color();
    }
    apply(context) {
        if (this.rt)
            context.invertY = this.invertY;
        else
            context.invertY = false;
        context.setRenderTarget(this.rt, this.clearColor, this.clearColorValue);
    }
}
export class WebGLDraw2DElementCMD extends Draw2DElementCMD {
    constructor() {
        super();
        this.type = RenderCMDType.DrawElement;
    }
    setRenderelements(value) {
        this._elemets = value;
    }
    apply(context) {
        if (this._elemets.length == 1) {
            context.drawRenderElementOne(this._elemets[0]);
        }
        else {
            this._elemets.forEach(element => {
                context.drawRenderElementOne(element);
            });
        }
    }
}
export class WebGLBlit2DQuadCMD extends Blit2DQuadCMD {
    static _init_() {
        WebGLBlit2DQuadCMD.SCREENTEXTURE_ID = Shader3D.propertyNameToID("u_MainTex");
        WebGLBlit2DQuadCMD.SCREENTEXTUREOFFSETSCALE_ID = Shader3D.propertyNameToID("u_OffsetScale");
        WebGLBlit2DQuadCMD.MAINTEXTURE_TEXELSIZE_ID = Shader3D.propertyNameToID("u_MainTex_TexelSize");
        WebGLBlit2DQuadCMD.GammaCorrect = Shader3D.getDefineByName("GAMMACORRECT");
    }
    constructor() {
        super();
        if (!WebGLBlit2DQuadCMD.SCREENTEXTURE_ID) {
            WebGLBlit2DQuadCMD._init_();
        }
        this.type = RenderCMDType.Blit;
        this._offsetScale = new Vector4();
        this._sourceTexelSize = new Vector4();
    }
    set source(value) {
        this._source = value;
        if (this._source) {
            this._sourceTexelSize.setValue(1.0 / this._source.width, 1.0 / this._source.height, this._source.width, this._source.height);
        }
    }
    apply(context) {
        let cacheInvert = context.invertY;
        if (!this._dest) {
            context.invertY = false;
            this.element.materialShaderData.addDefine(WebGLBlit2DQuadCMD.GammaCorrect);
        }
        else {
            this.element.materialShaderData.removeDefine(WebGLBlit2DQuadCMD.GammaCorrect);
        }
        this.element.materialShaderData._setInternalTexture(WebGLBlit2DQuadCMD.SCREENTEXTURE_ID, this._source);
        this.element.materialShaderData.setVector(WebGLBlit2DQuadCMD.SCREENTEXTUREOFFSETSCALE_ID, this._offsetScale);
        this.element.materialShaderData.setVector(WebGLBlit2DQuadCMD.MAINTEXTURE_TEXELSIZE_ID, this._sourceTexelSize);
        context.setRenderTarget(this._dest, false, Color.BLACK);
        context.drawRenderElementOne(this.element);
        context.invertY = cacheInvert;
    }
}
